export default "__VITE_ASSET__CwTkSgos__"